export default {
  "de": {
    "components-formstack": {
      "Arc'teryx Limited Warranty": "Beschränkte Arc'teryx Garantie",
      "choose files ": "Dateien durchsuchen",
      "Confirm Email Address": "",
      "Drag and drop or ": "Ziehen und legen Sie die Dateien zum Hochladen ab oder klicken Sie auf",
      "files": "Dateien",
      "Maximum": "Maximal",
      "Maximum file size is: 25 Mb.": "Die maximale Dateigröße für jedes Bild beträgt 25 MB.",
      "no files attached": "Keine Datei angehängt",
      "Order Number": "Bestellnummer",
      "Please agree to the conditions of the Arc'teryx Limited Warranty.": "Bitte akzeptiere die Bedingungen der beschränkten Arc'teryx Garantie.",
      "Please attach pictures of your product.": "Bitte füge Bilder von deinem Produkt hinzu.",
      "Please choose a value": "Bitte wählen Sie einen Wert aus",
      "Please enter your address.": "Bitte Adresse eingeben.",
      "Please enter your city.": "Bitte Ihre Stadt eingeben.",
      "Please enter your first name.": "Bitte geben Sie Ihren Vornamen ein.",
      "Please enter your last name.": "Bitte geben Sie Ihren Nachnamen ein.",
      "Privacy Policy": "Datenschutz",
      "Submit": "Senden",
      "Subtopic": "Unterthema",
      "This field is required.": "Dies ist ein Pflichtfeld.",
      "to upload": "hochzuladen",
      "Topic": "Thema",
      "Upload your pictures here": "Lade deine Bilder hier hoch. ",
      "Valid extensions are: jpg, jpeg, tif, tiff, png, pdf.": "Unterstützte Formate: jpg, jpeg, tif, tiff, png, pdf.",
      "We will only call you if there are questions regarding your request.": "Wir rufen Sie nur an, wenn es Fragen zu Ihrem Anliegen gibt.",
      "Your email addresses do not match.": "Ihre E-Mail-Adressen stimmen nicht überein."
    }
  },
  "en": {
    "components-formstack": {
      "Arc'teryx Limited Warranty": "",
      "choose files ": "",
      "Confirm Email Address": "",
      "Drag and drop or ": "",
      "files": "",
      "Maximum": "",
      "Maximum file size is: 25 Mb.": "",
      "no files attached": "",
      "Order Number": "",
      "Please agree to the conditions of the Arc'teryx Limited Warranty.": "",
      "Please attach pictures of your product.": "",
      "Please choose a value": "",
      "Please enter your address.": "",
      "Please enter your city.": "",
      "Please enter your first name.": "",
      "Please enter your last name.": "",
      "Privacy Policy": "",
      "Submit": "",
      "Subtopic": "",
      "This field is required.": "",
      "to upload": "",
      "Topic": "",
      "Upload your pictures here": "",
      "Valid extensions are: jpg, jpeg, tif, tiff, png, pdf.": "",
      "We will only call you if there are questions regarding your request.": "",
      "Your email addresses do not match.": ""
    }
  },
  "es": {
    "components-formstack": {
      "Arc'teryx Limited Warranty": "Garantía limitada Arc'teryx",
      "choose files ": "para cargar",
      "Confirm Email Address": "Confirmar el correo",
      "Drag and drop or ": "Arrastre y suelte o ",
      "files": "archivos",
      "Maximum": "Máximo",
      "Maximum file size is: 25 Mb.": "El tamaño máximo de cada imagen es de 25 MB.",
      "no files attached": "no se adjunta ningún archivo",
      "Order Number": "Número de orden",
      "Please agree to the conditions of the Arc'teryx Limited Warranty.": "Acepta las condiciones de la garantía limitada de Arc'teryx.",
      "Please attach pictures of your product.": "Adjunta fotos de tu producto.",
      "Please choose a value": "Por favor elige un valor",
      "Please enter your address.": "Introduzca su dirección.",
      "Please enter your city.": "Introduzca su ciudad.",
      "Please enter your first name.": "Por favor, introduzca su Nombre.",
      "Please enter your last name.": "Por favor, introduzca su Apellido.",
      "Privacy Policy": "Política de privacidad",
      "Submit": "Enviar",
      "Subtopic": "Subtema",
      "This field is required.": "Este campo es obligatorio.",
      "to upload": "para cargar",
      "Topic": "Tema",
      "Upload your pictures here": "Sube tus fotos aquí. ",
      "Valid extensions are: jpg, jpeg, tif, tiff, png, pdf.": "Formatos compatibles: jpg, jpeg, tif, tiff, png, pdf.",
      "We will only call you if there are questions regarding your request.": "Solo te llamaremos si hay alguna pregunta respecto a su solicitud.",
      "Your email addresses do not match.": "Sus direcciones de correo electrónico no coinciden."
    }
  },
  "fr": {
    "components-formstack": {
      "Arc'teryx Limited Warranty": "Garantie limitée Arc’teryx",
      "choose files ": "recherchez un fichier",
      "Confirm Email Address": "Confirmez votre adresse email",
      "Drag and drop or ": "Faites glisser et déposer un fichier ou",
      "files": "fichiers",
      "Maximum": "Maximum",
      "Maximum file size is: 25 Mb.": "La taille maximum de chaque image est de 25 Mo.",
      "no files attached": "aucun fichier attaché",
      "Order Number": "Numéro de commande",
      "Please agree to the conditions of the Arc'teryx Limited Warranty.": "Veuillez accepter les termes de la garantie limitée d’Arc'teryx.",
      "Please attach pictures of your product.": "Veuillez joindre des photos de votre produit.",
      "Please choose a value": "Veuillez choisir une valeur",
      "Please enter your address.": "Veuillez saisir votre adresse postale.",
      "Please enter your city.": "Veuillez saisir votre ville.",
      "Please enter your first name.": "Merci de saisir votre prénom.",
      "Please enter your last name.": "Merci de saisir votre nom.",
      "Privacy Policy": "Politique de Confidentialité",
      "Submit": "Envoyer",
      "Subtopic": "Objet de la demande",
      "This field is required.": "Ce champ est requis.",
      "to upload": "pour l’attacher",
      "Topic": "Type de demande",
      "Upload your pictures here": "Téléchargez vos photos ici. ",
      "Valid extensions are: jpg, jpeg, tif, tiff, png, pdf.": "Formats pris en charge : jpg, jpeg, tif, tiff, png, pdf.",
      "We will only call you if there are questions regarding your request.": "Nous ne vous contacterons qu’en cas de questions concernant votre demande.",
      "Your email addresses do not match.": "Les adresses e-mail ne correspondent pas."
    }
  },
  "it": {
    "components-formstack": {
      "Arc'teryx Limited Warranty": "",
      "choose files ": "",
      "Confirm Email Address": "",
      "Drag and drop or ": "",
      "files": "",
      "Maximum": "",
      "Maximum file size is: 25 Mb.": "",
      "no files attached": "",
      "Order Number": "",
      "Please agree to the conditions of the Arc'teryx Limited Warranty.": "",
      "Please attach pictures of your product.": "",
      "Please choose a value": "",
      "Please enter your address.": "",
      "Please enter your city.": "",
      "Please enter your first name.": "",
      "Please enter your last name.": "",
      "Privacy Policy": "",
      "Submit": "",
      "Subtopic": "",
      "This field is required.": "",
      "to upload": "",
      "Topic": "",
      "Upload your pictures here": "",
      "Valid extensions are: jpg, jpeg, tif, tiff, png, pdf.": "",
      "We will only call you if there are questions regarding your request.": "",
      "Your email addresses do not match.": ""
    }
  },
  "jp": {
    "components-formstack": {
      "Arc'teryx Limited Warranty": "アークテリクス限定保証",
      "choose files ": "ファイルを選択",
      "Confirm Email Address": "メールアドレスを確認",
      "Drag and drop or ": "ドラッグ＆ドロップまたは",
      "files": "ファイル",
      "Maximum": "最大",
      "Maximum file size is: 25 Mb.": "各画像のサイズは最大25MBまでにしてください。",
      "no files attached": "ファイルが添付されていません",
      "Order Number": "注文番号",
      "Please agree to the conditions of the Arc'teryx Limited Warranty.": "アークテリクス限定保証に定める各条件に同意してください。",
      "Please attach pictures of your product.": "製品の画像を添付してください。",
      "Please choose a value": "値を選択してください",
      "Please enter your address.": "住所を入力してください。",
      "Please enter your city.": "都市を入力してください。",
      "Please enter your first name.": "名前を入力して下さい。",
      "Please enter your last name.": "名字を入力して下さい。",
      "Privacy Policy": "プライバシーポリシー",
      "Submit": "送信",
      "Subtopic": "サブトピック",
      "This field is required.": "入力が必要なフィールドです。",
      "to upload": "してアップロード",
      "Topic": "トピック",
      "Upload your pictures here": "画像はこちらからアップロードしてください。",
      "Valid extensions are: jpg, jpeg, tif, tiff, png, pdf.": "対応ファイル形式：jpg, jpeg, tif, tiff, png, pdf。",
      "We will only call you if there are questions regarding your request.": "ご要望についてご不明な点がございましたら、お電話を差し上げます。",
      "Your email addresses do not match.": "メールアドレスが一致しません。"
    }
  },
  "no": {
    "components-formstack": {
      "Arc'teryx Limited Warranty": "Arc'teryx begrensede garanti",
      "choose files ": "bla gjennom filer",
      "Confirm Email Address": "Bekreft e-postadresse",
      "Drag and drop or ": "Dra og slipp eller ",
      "files": "filer",
      "Maximum": "Maks",
      "Maximum file size is: 25 Mb.": "Maksimal filstørrelse for hvert bilde er 25 MB.",
      "no files attached": "ingen fil vedlagt",
      "Order Number": "Ordrenummer",
      "Please agree to the conditions of the Arc'teryx Limited Warranty.": "Vennligst aksepter vilkårene for Arc'teryx’ begrensede garanti.",
      "Please attach pictures of your product.": "Vennligst legg ved bilder av produktet ditt.",
      "Please choose a value": "Vennligst velg en verdi",
      "Please enter your address.": "Oppgi adressen din.",
      "Please enter your city.": "Oppgi byen din.",
      "Please enter your first name.": "Oppgi fornavnet ditt.",
      "Please enter your last name.": "Oppgi etternavnet ditt.",
      "Privacy Policy": "Personvern",
      "Submit": "Send",
      "Subtopic": "Delemne",
      "This field is required.": "Dette feltet er obligatorisk.",
      "to upload": "for å laste opp",
      "Topic": "Emne",
      "Upload your pictures here": "Last opp bildene dine her.",
      "Valid extensions are: jpg, jpeg, tif, tiff, png, pdf.": "Støttede formater: jpg, jpeg, tif, tiff, png, pdf.",
      "We will only call you if there are questions regarding your request.": "Vi ringer deg kun hvis det er spørsmål angående forespørselen din.",
      "Your email addresses do not match.": "E-postadressene er ikke like."
    }
  },
  "sv": {
    "components-formstack": {
      "Arc'teryx Limited Warranty": "",
      "choose files ": "",
      "Confirm Email Address": "",
      "Drag and drop or ": "",
      "files": "",
      "Maximum": "",
      "Maximum file size is: 25 Mb.": "",
      "no files attached": "",
      "Order Number": "",
      "Please agree to the conditions of the Arc'teryx Limited Warranty.": "",
      "Please attach pictures of your product.": "",
      "Please choose a value": "",
      "Please enter your address.": "",
      "Please enter your city.": "",
      "Please enter your first name.": "",
      "Please enter your last name.": "",
      "Privacy Policy": "",
      "Submit": "",
      "Subtopic": "",
      "This field is required.": "",
      "to upload": "",
      "Topic": "",
      "Upload your pictures here": "",
      "Valid extensions are: jpg, jpeg, tif, tiff, png, pdf.": "",
      "We will only call you if there are questions regarding your request.": "",
      "Your email addresses do not match.": ""
    }
  },
  "zh": {
    "components-formstack": {
      "Arc'teryx Limited Warranty": "Arcteryx有限保修",
      "choose files ": "浏览文件",
      "Confirm Email Address": "确认电邮地址",
      "Drag and drop or ": "拖放或",
      "files": "个文件",
      "Maximum": "最多",
      "Maximum file size is: 25 Mb.": "每张照片的文件尺寸上限为25 MB。",
      "no files attached": "未附加任何文件",
      "Order Number": "订单号",
      "Please agree to the conditions of the Arc'teryx Limited Warranty.": "请同意Arc'teryx有限保修条款。",
      "Please attach pictures of your product.": "请附上产品照片",
      "Please choose a value": "请选择一个值",
      "Please enter your address.": "请输入您的地址。",
      "Please enter your city.": "请输入您的城市。",
      "Please enter your first name.": "请输入名字。",
      "Please enter your last name.": "请输入姓氏。",
      "Privacy Policy": "隐私政策",
      "Submit": "提交",
      "Subtopic": "副主题",
      "This field is required.": "该字段为必填项。",
      "to upload": "以上传",
      "Topic": "话题",
      "Upload your pictures here": "在此上传照片。",
      "Valid extensions are: jpg, jpeg, tif, tiff, png, pdf.": "支持格式：jpg, jpeg, tif, tiff, png, pdf。",
      "We will only call you if there are questions regarding your request.": "只有在对您的请求有任何疑问时，我们才会给您打电话。",
      "Your email addresses do not match.": "电子邮箱地址不匹配。"
    }
  }
};
